function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.8349 17.45L18.0038 14.7V10C18.0038 7.03 15.8324 4.56 13.0006 4.08V2H10.9994V4.08C8.1676 4.56 5.99624 7.03 5.99624 10V14.7L4.16509 17.45C3.96497 17.76 3.94496 18.15 4.11506 18.48C4.28517 18.81 4.62538 19.01 4.99561 19.01H19.0044C19.3746 19.01 19.7148 18.81 19.8849 18.48C20.055 18.15 20.035 17.76 19.8349 17.45ZM6.86679 17L7.82739 15.55C7.93746 15.39 7.99749 15.19 7.99749 15V10C7.99749 7.79 9.78861 6 12 6C14.2114 6 16.0025 7.79 16.0025 10V15C16.0025 15.2 16.0625 15.39 16.1726 15.55L17.1332 17H6.86679ZM9.99875 20H14.0013C14.0013 21.1 13.1007 22 12 22C10.8993 22 9.99875 21.1 9.99875 20Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=Bell.js.map